import './index.css';
import Aboutme from "./PortfolioContainer/AboutMe/Aboutme";
 
import Profile from "./PortfolioContainer/Home/Profile";
import Academic from "./PortfolioContainer/Academic/Academic/Academic";
import Contact from "./PortfolioContainer/ContactMe/Contact";
import NavBar from "./PortfolioContainer/NavBar/NavBar";
  
 


function App() {
 

  return (
    <>
 
      <NavBar/>
    
  
      <Profile/>

      <Aboutme />

      <Academic />
 
      <Contact />
    




    </>
  );

}

export default App;
